import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-arrow-bold',
  templateUrl: './icon-arrow-bold.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconArrowBoldComponent {}
